import { render, staticRenderFns } from "./crudContact.vue?vue&type=template&id=3a93ffbe&"
import script from "./crudContact.vue?vue&type=script&lang=js&"
export * from "./crudContact.vue?vue&type=script&lang=js&"
import style0 from "./crudContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports